import { MarkCredentialingReplyAsRead } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function MarkCredentialingReplyAsReadApi(payload = {}, options = {}) {
    try {
        const { wrapPayload = true } = options
        const requestPayload = wrapPayload
            ? {
                payload,
            }
            : payload

        const res = await getCharts(MarkCredentialingReplyAsRead, requestPayload)
        return res.data
    } catch (error) {
        return error
    }
}
